// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { CITY_DROPDOWN, DROPDOWN, ADD_FEEDBACK, INFORMATION_CARD, ADD_ENQUIRY, SUB_NEWSLETTER } from '../../common/constant'
import { get, post } from '../../common/api'


export const actionCity = createAsyncThunk('commonStore/actionCity', async (params, thunkAPI) => {
    return await get(CITY_DROPDOWN, params, thunkAPI)
})

export const actionDropdown = createAsyncThunk('commonStore/actionDropdown', async (params, thunkAPI) => {
    return await get(DROPDOWN, params, thunkAPI)
})

export const actionAddFeedback = createAsyncThunk('commonStore/actionAddFeedback', async (params, thunkAPI) => {
    return await post(ADD_FEEDBACK, params, thunkAPI)
})

export const actionInformationCard = createAsyncThunk('commonStore/actionInformationCard', async (params, thunkAPI) => {
    return await get(INFORMATION_CARD, params, thunkAPI)
})


export const actionAddEnquiryForm = createAsyncThunk('commonStore/actionAddEnquiryForm', async (params, thunkAPI) => {
    return await post(ADD_ENQUIRY, params, thunkAPI)
})
export const actionSubscribeNewsletter = createAsyncThunk('commonStore/actionSubscribeNewsletter', async (params, thunkAPI) => {
    return await post(SUB_NEWSLETTER, params, thunkAPI)
})

export const commonSlice = createSlice({
    name: 'commonStore',

    initialState: {

        //city list
        loadingCity: false,
        cityList: null,

        //dropdown data
        loadingDropdownData: false,
        dropdownData: null,

        //add feedback
        loadingAddFeedback: false,
        addFeedback: null,

        //information card
        loadingInformationCard: false,
        informationCard: null,

        //EnquiryAdd
        EnquiryAdd: null,
        LoadingEnquiryAdd: false,

        //Sub Newsletter
        loadingSubNewsLetter: false,
        subNewsLetter: null

    },
    reducers: {
        //reset or delete public store data
        resetCityResponse: (state) => {
            state.cityList = null
        },

        resetDropdownDataResponse: (state) => {
            state.dropdownData = null
        },
        resetAddFeedbackResponse: (state) => {
            state.addFeedback = null
        },
        resetInformationCradResponse: (state) => {
            state.informationCard = null
        },
        resetEnquiryAddFormResponse: (state) => {
            state.EnquiryAdd = null
        },
        resetSubNewsletterResponse: (state) => {
            state.subNewsLetter = null
        }
    },
    extraReducers: builder => {
        builder
            //city
            .addCase(actionCity.pending, (state) => {
                state.loadingCity = true
            })
            .addCase(actionCity.fulfilled, (state, action) => {
                state.loadingCity = true
                state.cityList = action.payload
            })
            .addCase(actionCity.rejected, (state) => {
                state.loadingCity = false
            })

            //dropdown data
            .addCase(actionDropdown.pending, (state) => {
                state.loadingDropdownData = true
            })
            .addCase(actionDropdown.fulfilled, (state, action) => {
                state.loadingDropdownData = false
                state.dropdownData = action.payload
            })
            .addCase(actionDropdown.rejected, (state) => {
                state.loadingDropdownData = false
            })

            //add feedback data
            .addCase(actionAddFeedback.pending, (state) => {
                state.loadingAddFeedback = true
            })
            .addCase(actionAddFeedback.fulfilled, (state, action) => {
                state.loadingAddFeedback = false
                state.addFeedback = action.payload
            })
            .addCase(actionAddFeedback.rejected, (state) => {
                state.loadingAddFeedback = false
            })

            //information card
            .addCase(actionInformationCard.pending, (state) => {
                state.loadingInformationCard = true
            })
            .addCase(actionInformationCard.fulfilled, (state, action) => {
                state.loadingInformationCard = false
                state.informationCard = action.payload
            })
            .addCase(actionInformationCard.rejected, (state) => {
                state.loadingInformationCard = false
            })

            //Enquiry add
            .addCase(actionAddEnquiryForm.pending, (state) => {
                state.LoadingEnquiryAdd = true
            })
            .addCase(actionAddEnquiryForm.fulfilled, (state, action) => {
                state.LoadingEnquiryAdd = false
                state.EnquiryAdd = action.payload
            })
            .addCase(actionAddEnquiryForm.rejected, (state) => {
                state.LoadingEnquiryAdd = false
            })

            //SubNewsletter list
            .addCase(actionSubscribeNewsletter.pending, (state) => {
                state.loadingSubNewsLetter = true
            })
            .addCase(actionSubscribeNewsletter.fulfilled, (state, action) => {
                state.loadingSubNewsLetter = false
                state.subNewsLetter = action.payload
            })
            .addCase(actionSubscribeNewsletter.rejected, (state) => {
                state.loadingSubNewsLetter = false
            })
    }
})
export const { resetCityResponse, resetDropdownDataResponse, resetAddFeedbackResponse, resetInformationCradResponse, resetEnquiryAddFormResponse, resetSubNewsletterResponse } = commonSlice.actions

export default commonSlice.reducer